var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"tableRow",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.openShop(_vm.shop.id)}}},[_c('td',[_vm._v(_vm._s(_vm.shopName))]),(!_vm.isMobile)?_c('td'):_vm._e(),(!_vm.isMobile)?_c('td'):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }